import { render } from "./ChallengeButton.vue?vue&type=template&id=9ca6dca0"
import script from "./ChallengeButton.vue?vue&type=script&lang=js"
export * from "./ChallengeButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__